document.addEventListener("DOMContentLoaded", () => {
    const tabs = document.querySelectorAll(".tab");
    const tabContents = document.querySelectorAll(".tab-content");

    tabs.forEach(tab => {
        tab.addEventListener("click", () => {
            // Deactivate all tabs and contents
            tabs.forEach(t => t.classList.remove("active"));
            tabContents.forEach(content => content.classList.remove("active"));

            // Activate clicked tab and corresponding content
            tab.classList.add("active");
            document.getElementById(tab.dataset.target).classList.add("active");
        });
    });

    // 1) Hide rows beyond the 5th in every table
  document.querySelectorAll('.tradein-text table').forEach(function(table) {
    const rows = table.querySelectorAll('tbody tr');
    // If more than 5 rows, hide extras
    if (rows.length > 5) {
      for (let i = 5; i < rows.length; i++) {
        rows[i].classList.add('hidden-row');
      }
    }
  });

  // 2) When user clicks "Voir toutes les valeurs...", show the entire table in a modal
  document.querySelectorAll('.see-all-values').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      // Find the table associated with this link
      const parentBlock = link.closest('.tradein-text');
      if (!parentBlock) return;
      const originalTable = parentBlock.querySelector('table');
      if (!originalTable) return;

      // Clone that table so we can display ALL rows in the modal
      const clonedTable = originalTable.cloneNode(true);
      clonedTable.querySelectorAll('.hidden-row').forEach(row => {
        row.classList.remove('hidden-row');
      });

      // Insert cloned table into the modal
      const modalTableContainer = document.getElementById('modalTableContainer');
      modalTableContainer.innerHTML = '';           // Clear old content
      modalTableContainer.appendChild(clonedTable); // Put new table in

      // Optionally set modal title from data-title
      const customTitle = link.getAttribute('data-title') || 'Valeurs de reprise';
      document.getElementById('modalTitle').textContent = customTitle;

      // Show the modal
      document.getElementById('fullTableModal').classList.add('active');
    });
  });

  // 3) Close the modal on overlay or close button
  document.querySelectorAll('[data-close="modal"]').forEach(function(closeElem) {
    closeElem.addEventListener('click', function() {
      document.getElementById('fullTableModal').classList.remove('active');
    });
  });
});
